import { handleAddToCart as handleAddToCartAction } from "@/components/PDP/ProductForm/_actions/addToCart";
import {
	getCartDatalayerDetails,
	getItemListData,
	useDataLayerContext,
} from "@/datalayer/DataLayerContextProvider";
import { ProductData } from "@/lib/5874/types";
import EventBus, { Events } from "@/lib/_event-bus/event-bus";
import { useCartContext } from "@/providers/CartContextProvider";
import { useState } from "react";

export const useCarouselCart = () => {
	const [productAddedToCart, setProductAddedToCart] = useState(0);
	const { setCart, setIsModifyingCart, isModifyingCart, cart } =
		useCartContext();
	const { addToCart } = useDataLayerContext();

	const addToCartHandler = async (product: ProductData) => {
		setIsModifyingCart(true);
		const res = await handleAddToCartAction([{ id: product.id, quantity: 1 }]);

		if (res.status === "success" && res.data) {
			setCart(res.data);
			setProductAddedToCart(product.id);
			setTimeout(() => setProductAddedToCart(0), 1500);

			EventBus.dispatch(Events.productAddToCart, {
				product,
				cart: res.data,
			});

			// Datalayer event
			const cartDetails = getCartDatalayerDetails(cart);
			const datalayerProduct = {
				product: product,
				quantity: 1,
				variantId: product.id,
			};

			addToCart({
				products: [datalayerProduct],
				itemListId: getItemListData(product).itemListId,
				itemListName: getItemListData(product).itemListName,
				cart: cartDetails,
			});
		}

		setIsModifyingCart(false);
	};

	return {
		productAddedToCart,
		addToCartHandler,
		isModifyingCart,
	};
};
